const getUrlParameter = (name) => {
    const nameClean = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + nameClean + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const removeUrlParameter = (url, paramKey) => {
  const r = new URL(url);
  r.searchParams.delete(paramKey);

  history.replaceState(null, '', r.href);
}